import {
  ChargerExcludeModel,
  ChargerExcludeOrderTypes,
  SearchChargerExclude,
  ChargerExcludeCreateModel,
} from "@/models/chargerExclude";
import { AxiosResponse } from "axios";
import qs from "qs";
import { httpClient } from "./API";

export const getChargerExcludeTotalAPI = async (
  search: SearchChargerExclude
) => {
  return httpClient.get("core/internal/calgary/chargerSuspensions/count/", {
    params: { ...search },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const getChargerExcludeAPI = async (
  nextPage: number,
  pageSize: number,
  search: SearchChargerExclude,
  sort?: ChargerExcludeOrderTypes
): Promise<AxiosResponse<ChargerExcludeModel[]>> => {
  const sortParams: string[] = [];
  if (sort) {
    Object.keys(sort).map((it) => {
      const key = it as keyof ChargerExcludeOrderTypes;
      if (sort[key]) {
        sortParams.push([key, sort[key]].join(","));
      }
      return it;
    });
  }

  return httpClient.get("core/internal/calgary/chargerSuspensions/", {
    params: { ...search, sort: sortParams, page: nextPage, size: pageSize },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const getChargerExcludeDetailAPI = async (
  id: number
): Promise<AxiosResponse<ChargerExcludeModel>> => {
  return httpClient.get("core/internal/calgary/chargerSuspensions/" + id);
};

export const createChargerExcludeAPI = async (
  data: ChargerExcludeCreateModel
): Promise<AxiosResponse<any>> => {
  data.startAt = new Date(data.startAt || "").toISOString();
  return httpClient.post("core/internal/calgary/chargerSuspensions", data);
};

export const editChargerExcludeAPI = async (
  id: number,
  data: ChargerExcludeCreateModel
): Promise<AxiosResponse<any>> => {
  data.startAt = new Date(data.startAt || "").toISOString();
  return httpClient.put("core/internal/calgary/chargerSuspensions/" + id, data);
};

export const deleteChargerExcludeAPI = async (
  id: number
): Promise<AxiosResponse<any>> => {
  return httpClient.delete("core/internal/calgary/chargerSuspensions/" + id);
};
